<template>
  <sui-form-field :width="field.width || width || 16" :disabled="disabled" :required="field.required" :error="isInvalid" v-if="field && !field.hidden">
    <label v-show="field.label">
      {{field.label}}
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="field.warning" v-if="field.warning"><i class="warning sign yellow fitted icon" /></span>
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="tooltip" v-if="tooltip"><i class="help circle blue fitted icon" /></span>
    </label>
    <sui-input :type="type" v-model.trim="$attrs.value" v-autoselect="field.autoselect || false" :icon="icon" :disabled="field.readonly" :loading="loading" :placeholder="fieldPlaceholder" :min="field.min" :max="field.max" @input="onInput" v-if="!options.length" />
    <div class="ui fluid buttons" v-if="options.length">
      <sui-input class="right action" :type="type" v-model.trim="$attrs.value" v-autoselect="field.autoselect || false" :icon="icon" :disabled="field.readonly" :placeholder="fieldPlaceholder" :min="field.min" :max="field.max" @input="onInput" />
      <sui-dropdown class="icon button" :class="{disabled: field.readonly}" floating :options="options" :search-in-menu="{icon: 'search'}" @input="onSelect" />
    </div>
    <small v-if="description">
      {{description}}
    </small>
    <small v-if="field.examples && !field.readonly">
      Example{{field.examples.length > 1 ? 's' : ''}}:
      <span class="example" v-for="example in field.examples" :key="example" @click.prevent="set(example)">{{example}}</span>
    </small>
    <small class="errors">
      {{error}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  export default {
    name: 'FormEntityInput',
    mixins: [
      FormField,
    ],
    props: {
      description: {
        type: String,
        required: false,
        default: '',
      },
      type: {
        type: String,
        required: false,
        default: 'text',
      },
      disabled: {
        required: false,
        default: false,
      },
      options: {
        type: Array,
        required: false,
        default() {
          return []
        },
      },
    },
    methods: {
      onSelect(newValue) {
        this.set(newValue)
      },
    },
  }
</script>

<style scoped>
  .tooltip { float: right; }
  .example { margin-left: .1em; color: #48c; cursor: pointer; }
  .example:after { content: ", "; color: #000; }
  .example:hover { color: #6ae; }
  .example:last-child:after { content: ""; }
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
  .monospace >>> input { font-family: monospace!important; }

  .dropdown >>> .menu { max-height: 40vh; overflow-y: auto; overflow-x: hidden; }
  .dropdown >>> .menu .input { margin: 1em!important; width: auto!important; }
  .dropdown >>> .menu .item.item { padding: .4em 1em!important; min-height: 0!important; }
</style>
